import styled from 'styled-components';

export const Wrapper = styled.div`
    background-color: ${({ theme }) => theme.colors.neutral000};
    border: 1px solid ${({ theme }) => theme.colors.primary300};
    border-radius: 3px;
    display: flex;
    align-items: start;
    justify-content: center;
    margin-top: 8px;
    height: 106px;
    width: 180px;
`;

export const Text = styled.p`
    color: ${({ theme }) => theme.colors.neutral900};
    font-size: 11px;
    line-height: 16px;
    width: 150px;
    margin-top: 12px;
`;

export const ArrowImg = styled.img`
    margin-left: 28px;
    position: absolute;
    margin-top: 50px;
`;

export const IconImg = styled.img`
    margin-left: 8px;
    position: absolute;
    margin-top: 70px;
    width: 155px;
    height: 24px;
`;
